import { createFileRoute } from "@tanstack/react-router"

import { SpendPage } from "@/admin/spend/page"
import { loadSpend } from "@/admin/spend/spend-data"

const SpendRoute = () => <SpendPage spend={Route.useLoaderData()} />

export const Route = createFileRoute("/_terminalAdmin/terminal/admin/spend")({
  loader: () => loadSpend(),
  component: SpendRoute,
})
